export const typeChoices = [{ id: "http", name: "HTTP" }];

export const statusChoices = [
  { id: "active", name: "Active" },
  { id: "paused", name: "Paused" },
  { id: "suspended", name: "Suspended" },
];

export const contentFormatChoices = [
  { id: "JSONARRAY", name: "JSON Array" },
  { id: "JSONLINES", name: "JSON Lines" },
  { id: "JSONOBJECT", name: "JSON Object" },
];
